<header>
    <div class="container">
      <div class="d-flex flex-row justify-content-between">
         <a class="navbar-brand my-2" routerLink="/home">
          <img src="assets/custom/images/logo_uner.png" [attr.alt]="'menu.header.image.logo' | translate"/>
        </a> 
      </div>
    </div>
  </header>
  